import { ManualCodeEntry } from '@/components/manual-code-entry/component';
import { Scanner } from '@/components/scanner';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Button, Flex, Text } from '@mantine/core';
import { AnimatePresence, motion } from 'motion/react';
import { useState } from 'react';
import { useBaleInboundContext } from '../hook';
import styles from '../styles.module.css';

export const ManualInboundScannedMaterialsDisplay: React.FC<{
	materials: Array<{
		value: string;
		name: string;
		emoji: string;
		count: number;
	}>;
}> = ({ materials }) => (
	<motion.div
		initial={{ opacity: 0, y: 20 }}
		animate={{ opacity: 1, y: 0 }}
		exit={{ opacity: 0, y: 20 }}
		transition={{ duration: 0.3, ease: 'easeOut' }}
		style={{ width: '100%' }}
	>
		<Flex px="md" py="xs" w="100%" align="center" justify="center" gap="xs">
			<AnimatePresence>
				{materials.map((material, index) => (
					<motion.div
						key={material.value}
						initial={{ opacity: 0, scale: 0.8 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={{ opacity: 0, scale: 0.8 }}
						transition={{
							duration: 0.3,
							delay: index * 0.1,
							ease: 'easeOut',
						}}
						style={{ flex: 1 }}
					>
						<Flex
							gap="xs"
							align="center"
							justify="center"
							p="sm"
							className={styles.statsCardAccepted}
						>
							<Text size="lg">{material.emoji}</Text>
							<Flex direction="column" align="center" gap={2}>
								<motion.div
									key={material.count}
									initial={{ scale: 1.2 }}
									animate={{ scale: 1 }}
									transition={{ duration: 0.2 }}
								>
									<Text size="lg" fw={700} c="green" lh={1}>
										{material.count}
									</Text>
								</motion.div>
								<Text size="xs" c="green" fw={500} lh={1}>
									{material.name}
								</Text>
							</Flex>
						</Flex>
					</motion.div>
				))}
			</AnimatePresence>
		</Flex>
	</motion.div>
);

export const ManualInboundAddScanPage = () => {
	const { setPage, handleManualCreateBaleScan, manualCodeEntryOpen, setManualCodeEntryOpen } =
		useBaleInboundContext();
	const [code, setCode] = useState('');

	const handleBack = () => {
		setPage('MANUAL_CREATE:ROOT');
	};

	return (
		<MobileContainer header={<MobileHeader title="Add Bales" onBack={handleBack} />}>
			<Scanner onScan={(code) => handleManualCreateBaleScan('ADD', code)} />
			<ManualCodeEntry
				value={code}
				setValue={setCode}
				open={manualCodeEntryOpen}
				instructions="Please enter the code found on the bale tag."
				onClose={() => setManualCodeEntryOpen(false)}
				shouldValidate
				actions={({ isValid, onClose }) => {
					return (
						<Flex gap="sm">
							<Button
								variant="filled"
								fullWidth
								onClick={() => {
									onClose();
									setCode('');
								}}
							>
								Cancel
							</Button>
							<Button
								variant="filled"
								fullWidth
								onClick={() => handleManualCreateBaleScan('ADD', code).then(() => onClose())}
								disabled={!isValid}
							>
								Add Bales
							</Button>
						</Flex>
					);
				}}
			/>
		</MobileContainer>
	);
};
